import {useQuery} from 'react-query';
import {getMessages} from '../../../services/message';

const UseGetMessages = () => {
  const {
    data: messages,
    isLoading: isMessagesLoading,
    isSuccess,
    refetch,
  } = useQuery(['getMessages'], getMessages);
  return {messages, isMessagesLoading, isSuccess, refetch};
};

export default UseGetMessages;
